import React, { useState, useEffect } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';

export default function ResponsivePie({ pieData, COLORS, onSliceClick, activeKey }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const totalValue = pieData.reduce((sum, item) => sum + item.value, 0);

    const handleSliceClick = (data) => {
        if (onSliceClick && data) onSliceClick(data);
    };

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ width: '100%', height: isMobile ? 200 : 260 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                        <Pie
                            data={pieData}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius={isMobile ? 65 : 85}
                            label={isMobile ? false : ({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                            onClick={handleSliceClick}
                            style={{ cursor: onSliceClick ? 'pointer' : 'default' }}
                        >
                            {pieData.map((entry) => (
                                <Cell
                                    key={entry.key}
                                    fill={COLORS[entry.key]}
                                    // Dim non-active slices when filter is active
                                    opacity={activeKey && activeKey !== entry.key ? 0.25 : 1}
                                    stroke={activeKey === entry.key ? '#fff' : 'none'}
                                    strokeWidth={activeKey === entry.key ? 3 : 0}
                                />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Mobile legend */}
            {isMobile && (
                <div style={{ width: '100%', padding: '16px 8px 0', display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {pieData.map((entry) => {
                        const percentage = totalValue > 0 ? ((entry.value / totalValue) * 100).toFixed(0) : 0;
                        const isActive = activeKey === entry.key;
                        const isDimmed = activeKey && !isActive;
                        return (
                            <div
                                key={entry.key}
                                onClick={() => onSliceClick?.(entry)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: 10, fontSize: 13,
                                    cursor: onSliceClick ? 'pointer' : 'default',
                                    opacity: isDimmed ? 0.35 : 1,
                                    fontWeight: isActive ? 700 : 400,
                                    transition: 'opacity .2s',
                                }}
                            >
                                <div style={{
                                    width: 12, height: 12, borderRadius: '50%',
                                    backgroundColor: COLORS[entry.key], flexShrink: 0,
                                    border: isActive ? '2px solid #333' : 'none',
                                }} />
                                <div style={{ color: 'var(--text)' }}>
                                    {entry.name}: <span style={{ color: 'var(--text-muted)' }}>{entry.value} ({percentage}%)</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}